import React, { useContext, useState } from 'react';
// design
import { Modal, Form, Input, Select } from 'antd';
import MaskedInput from 'antd-mask-input'
import { ExclamationCircleOutlined } from '@ant-design/icons';
// context
import { GlobalContext } from "../context/globalContext";
import getStateList from "../utils/stateList";
// method
import { getMethod, postMethod } from '../services/methods';

const { confirm } = Modal;
const { Option } = Select;

function AddUserDialog({ visible, onCreate, onCancel }) {
    // context
    const { contextData, dispatch } = useContext(GlobalContext);
    const [selectedState, setSelectedState] = useState(null);
    const [stateList] = useState(getStateList().data)
    const [role, setRole] = useState("delegate");

    const onFieldsChange = (changedFields, allFields) => {
        if (changedFields[0].name == "role") {
            setRole(changedFields[0].value)
        }
    }

    const [form] = Form.useForm();
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 4 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 20 },
        },
    };

    const showConfirm = async () => {
        let getConfirm;

        if (form.getFieldValue("role") == "delegate") {
            getConfirm = await postMethod("/user/confirm", { phone: form.getFieldValue("phone") });
        }

        form
            .validateFields()
            .then(() => {
                if (form.getFieldValue("role") != "delegate") {
                    submit();
                    return;
                }
                confirm({
                    title: 'Sms ile gönderilen kodu teyit ediniz.',
                    icon: <ExclamationCircleOutlined />,
                    content: getConfirm.message,
                    okText: "Onayla",
                    cancelText: "İptal",
                    onOk() {
                        submit()
                    },
                    onCancel() {
                        form.resetFields();
                        onCancel()
                    },
                });
            })
            .catch((info) => {
                console.log('Validate Failed:', info);
            });

    }

    const submit = () => {
        onCreate(form.getFieldsValue());
        form.resetFields();
        setRole("delegate")
    }

    return (
        <Modal
            visible={visible}
            title="Yeni kullanıcı oluştur"
            okText="Ekle"
            cancelText="İptal"
            onCancel={onCancel}
            onOk={() => showConfirm()}
        >

            <Form
                {...formItemLayout}
                form={form}
                layout="horizontal"
                name="form_in_modal"
                onFieldsChange={onFieldsChange}
                initialValues={{
                    modifier: 'public',
                    role: "delegate"
                }}
            >
                <Form.Item
                    name="role"
                    label="Rol"
                    rules={[
                        {
                            required: true,
                            message: 'Lütfen bu alanı doldurunuz!',
                        },
                    ]}
                >

                    <Select allowClear>
                        {
                            ["admin"].includes(contextData.userData.role) &&
                            <>
                                <Option value="admin">Admin</Option>
                                <Option value="admin-center">Admin Center</Option>
                            </>
                        }
                        {
                            ["admin", "admin-center"].includes(contextData.userData.role) &&
                            <>
                                <Option value="admin-state">İl admin</Option>
                            </>
                        }
                        {
                            (["admin", "admin-center"].includes(contextData.userData.role) ||
                                contextData.userData.role == "admin-state") &&
                            <Option value="admin-county">İlçe admin</Option>
                        }
                        <Option value="delegate">Teşkilat Mensubu</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="name"
                    label="Ad"
                    rules={[
                        {
                            required: true,
                            message: 'Lütfen bu alanı doldurunuz!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="surname"
                    label="Soyad"
                    rules={[
                        {
                            required: true,
                            message: 'Lütfen bu alanı doldurunuz!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                {role != "delegate" &&
                    <>
                        <Form.Item
                            name="password"
                            label="Şifre"
                            rules={[
                                {
                                    required: true,
                                    message: 'Lütfen bu alanı doldurunuz!',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                    </>
                }

                <Form.Item
                    name="phone"
                    label="Tel"
                    rules={[
                        {
                            required: true,
                            message: 'Lütfen bu alanı doldurunuz!',
                        },
                    ]}
                >
                    <MaskedInput mask="111 111 11 11" />
                </Form.Item>

                {role != "delegate" &&
                    <>
                        <Form.Item
                            name="state"
                            label="İl"
                            normalize={value => (value || '').toLocaleUpperCase('tr-TR')}
                            rules={[
                                {
                                    required: true,
                                    message: 'Lütfen bu alanı doldurunuz!',
                                },
                            ]}
                        >

                            <Select
                                onChange={(value) => { setSelectedState(value); form.setFieldsValue({ county: "" }) }}
                                autoComplete="off"
                                showSearch
                                optionFilterProp="children"
                                allowClear
                                filterOption={(input, option) =>
                                    option.children.toLocaleLowerCase('tr').indexOf(input.toLocaleLowerCase('tr')) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.children.toLocaleLowerCase('tr').localeCompare(optionB.children.toLocaleLowerCase('tr'))
                                }
                            >
                                {
                                    stateList.map(item => (
                                        <Option key={item.il_adi} value={item.il_adi}>{item.il_adi}</Option>
                                    ))
                                }
                            </Select>

                        </Form.Item>

                        {
                            selectedState &&
                            <Form.Item
                                name="county"
                                label="İlçe"
                                normalize={value => (value || '').toLocaleUpperCase('tr-TR')}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Lütfen bu alanı doldurunuz!',
                                    },
                                ]}
                            >

                                <Select
                                    autoComplete="off"
                                    showSearch
                                    optionFilterProp="children"
                                    allowClear
                                    filterOption={(input, option) =>
                                        option.children.toLocaleLowerCase('tr').indexOf(input.toLocaleLowerCase('tr')) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.children.toLocaleLowerCase('tr').localeCompare(optionB.children.toLocaleLowerCase('tr'))
                                    }
                                >
                                    {
                                        stateList.filter(item => item?.il_adi?.toLocaleLowerCase('tr') == selectedState?.toLocaleLowerCase('tr'))[0]?.ilceler.map(item => (
                                            <Option key={item.ilce_adi} value={item.ilce_adi}>{item.ilce_adi}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>
                        }
                    </>
                }

            </Form>

        </Modal >
    );
};

export default AddUserDialog;
